import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainers(agro_exporter_process_id, filters = {}) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_containers/${agro_exporter_process_id}`,
      { params: filters }
    );
  },
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_containers/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchExporterQualityTemplates(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_containers/list_quality_templates/${agro_exporter_process_id}`
    );
  },
};
